<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  noAttributesAvailable: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const emptyMessage = computed(() =>
  props.noAttributesAvailable
    ? t('CONVERSATION_WORKFLOW.REQUIRED_ATTRIBUTES.NO_ATTRIBUTES_AVAILABLE')
    : t('CONVERSATION_WORKFLOW.REQUIRED_ATTRIBUTES.NO_ATTRIBUTES')
);
</script>

<template>
  <div class="flex justify-between items-center px-4 py-4 w-full">
    <div
      class="flex justify-center items-center py-6 w-full custom-dashed-border"
    >
      <span class="text-sm text-n-slate-11">
        {{ emptyMessage }}
      </span>
    </div>
  </div>
</template>
